<div style="height: 100%; position: relative; padding-top: 26px">
  <div style="color: #FFFFFFDE; padding: 0 10px; font-weight: 600; position: absolute; top:0; right:0; left:0">
    <div class="p-panel-header ng-star-inserted" id="p-panel-2-titlebar"><span
      class="p-panel-title ng-star-inserted" id="p-panel-2_header">Memory</span>
      <div class="p-panel-icons">
        <button
          style="padding: 0 5px"
          pButton
          pRipple
          label="Split"
          class="p-button-raised"
          (click)="handleSplitMemoryAreaToggle()"
          [ngClass]="{'p-button-outlined': !splitMemoryArea}"
        ></button>
      </div>
    </div>
  </div>
  <!--  </ng-template>-->
  <!--  <ng-template pTemplate="content">-->
  <div class="memory-map">
    <div class="text-muted memory-index-lsb-bar">
      <div *ngFor="let i of memoryColsIndexes" class="memory-index-lsb"><small>{{i}}</small></div>
    </div>
    <div [ngClass]="{'splitted-top': splitMemoryArea}" class="memory-area">
      <div class="text-muted memory-index-msb-bar">
        <div *ngFor="let i of memoryRowsIndexes" class="memory-index-msb"><small>{{i}}</small></div>
      </div>
      <div class="source-code memory-content">
        <div class="memory-block"
             (click)="memoryCellClick($event, 0, j)"
             *ngFor="let i of memoryCellViews; let j = index"
             [ngClass]="i.style"
        >
          <div><span>{{i.strValue}}</span></div>
          <input
            (blur)="editingCell[0] = -1"
            (keyup.enter)="setCellValue(0, j)"
            (keyup.escape)="editingCell[0] = -1"
            *ngIf="editingCell[0] === j"
            [(ngModel)]="newCellValue"
            appAutofocus class="memory-cell-input"
            title="New cell value"
          >
        </div>
      </div>

    </div>
    <div *ngIf="splitMemoryArea" class="memory-area splitted-bottom">
      <div class="text-muted memory-index-msb-bar">
        <div *ngFor="let i of memoryRowsIndexes" class="memory-index-msb"><small>{{i}}</small></div>
      </div>
      <div class="source-code memory-content">
        <div class="memory-block"
             (click)="memoryCellClick($event, 0, j)"
             *ngFor="let i of memoryCellViews; let j = index"
             [ngClass]="i.style"
        >
          <div><span>{{i.strValue}}</span></div>
          <input
            (blur)="editingCell[0] = -1"
            (keyup.enter)="setCellValue(0, j)"
            (keyup.escape)="editingCell[0] = -1"
            *ngIf="editingCell[0] === j"
            [(ngModel)]="newCellValue"
            appAutofocus class="memory-cell-input"
            title="New cell value"
          >
        </div>
      </div>
    </div>
    <p-messages></p-messages>
  </div>
  <!--  </ng-template>-->
</div>
